import Button from "@components/Common/Button";
import ErrorIcon from "@icons/ErrorIcon";
import React from "react";
import { useTranslation } from "react-i18next";

interface AuthErrorPageProps {
  onRetry: () => void;
}

const AuthErrorPage: React.FC<AuthErrorPageProps> = ({ 
  onRetry 
}) => {
  const { t } = useTranslation("translation");

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-mainColor p-6 text-center">
      <div className="mb-8 flex size-24 items-center justify-center rounded-full bg-errorColor/10 text-errorColor">
        <ErrorIcon />
      </div>

      <h2 className="mb-4 text-3xl font-bold text-mainTextColor">
        {t("session_expired")}
      </h2>

      <p className="mb-10 max-w-lg text-lg text-secondTextColor">
        {t("session_expired_message")}
      </p>

      <div className="w-full max-w-xs">
        <Button 
          className="w-full py-3"
          onClick={onRetry}
        >
          {t("retry")}
        </Button>
      </div>
    </div>
  );
};

export default AuthErrorPage;

